import { render, staticRenderFns } from "./WatchVideo.vue?vue&type=template&id=4b4ba2fb&scoped=true"
import script from "./WatchVideo.vue?vue&type=script&lang=js"
export * from "./WatchVideo.vue?vue&type=script&lang=js"
import style0 from "./WatchVideo.vue?vue&type=style&index=0&id=4b4ba2fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ba2fb",
  null
  
)

export default component.exports